import { campaignMetricsConstants, globalConstants, CAMPAIGN_METRICS_PAGINATION } from "../../constants";

const { SUCCESS } = globalConstants;
const { GET_CAMPAIGN_METRICS } = campaignMetricsConstants;

//Reducer initial state
const initialState = {
  campaignMetricsData: [],
  campaignMetricsPagination: { ...CAMPAIGN_METRICS_PAGINATION.INITIAL },
};

export const campaignMetricsReducer = (state = initialState, action) => {
  if (action.type === GET_CAMPAIGN_METRICS + SUCCESS) {
    return {
      ...state,
      campaignMetricsData: action.data.data,
      campaignMetricsPagination: action.data.page,
    };
  } else {
    return state;
  }
};
